/* global rp$, document, window */
const runScriptOnReady = require('public/js/lib/run-script-on-ready');

function handleProductCarouselResponse({ $carouselContainer, $carouselResponse }) {
    return function (evt, response) {
        $carouselContainer.parent().addClass('has-recommendations');
        $carouselContainer.addClass('has-recommendations');
        $carouselResponse.html(response.html);

        const isListView = $carouselContainer.data('display-list');
        if (isListView) {
            rp$('.search-listing-module').find('.add-to-cart.enabled').add_to_cart();
            return;
        }

        const $carouselWrapper = $carouselResponse.find('.product-carousel-container');
        const $carousel = rp$('.product-carousel');
        const $carouselItems = rp$('.each-product-carousel-item');
        $carouselWrapper.on('changed.owl.carousel', function (event) {
            const currentIndex = event.item.index; 
            const totalItems = event.item.count;

           
            const $prevButton = rp$('.owl-prev');
            const $nextButton = rp$('.owl-next');

            if (currentIndex === 0) {
                $prevButton.addClass('disabled');
            } else {
                $prevButton.removeClass('disabled');
            }

            if (currentIndex + event.page.size >= totalItems) {
                $nextButton.addClass('disabled');
            } else {
                $nextButton.removeClass('disabled');
            }
        });

        $carouselItems.ready(function () {
            const $cartButton = $carouselItems.find('.add-to-cart.enabled');
            typeof $cartButton.add_to_cart === 'function' && $cartButton.add_to_cart();
        });

        $carousel.addClass('multiple-layout');
        $carouselWrapper.addClass('owl-carousel').owlCarousel({
            margin: 10,
            nav: true,
            navText: false,
            loop: true,
            dots: true,
            items: 1,
        });
    }
};

function initializeProductCarousel() {
    rp$('.product-carousel-component').each((idx, carouselModule) => {
        const $carouselContainer = rp$(carouselModule).find('.product-carousel');
        const $carouselResponse = rp$(carouselModule).find('.carousel-container-response');

        const eventHandler = handleProductCarouselResponse({ $carouselContainer, $carouselResponse });

        rp$(document).off('productGetCarouselItems:response', eventHandler).on('productGetCarouselItems:response', eventHandler);
    });
}

rp$.fn.product_carousel = initializeProductCarousel;
runScriptOnReady('product_carousel', initializeProductCarousel);
